import Head from 'next/head';
import React from 'react';
import { images } from '../../Constants/ImageUrls';

export default function VaccinationHead() {
  return (
    <Head>
      <link
        rel="preload"
        href={images.FooterTopWave}
        as="image"
        fetchPriority="high"
      />
    </Head>
  );
}
